import ExpendutureGenerator from './generator/ExpenditureGenerator';

const ExpenditureReport = () => <ExpendutureGenerator />;

export default ExpenditureReport;
